export const formatUserAudit = (u) => {
  if (!u) return "";
  if (typeof u === "string") return u;
  return u.username || u.name || u.id || "";
};

export const formatClosedBy = (session) => {
  if (!session?.closed_by) return "";
  const closer = formatUserAudit(session.closed_by);
  const ts = session.closed_at || session.scan_out_closed_at;
  if (!ts) return closer ? `Closed by ${closer}` : "";
  try {
    const d = new Date(ts);
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    return `Closed by ${closer} at ${hh}:${mm}`;
  } catch {
    return `Closed by ${closer}`;
  }
};

export const formatPublishedBy = (allocation) => {
  if (!allocation?.published_by) return "";
  const pub = formatUserAudit(allocation.published_by);
  const ts = allocation.published_at;
  if (!ts) return pub ? `Last published by ${pub}` : "";
  try {
    const d = new Date(ts);
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    return `Last published by ${pub} at ${hh}:${mm}`;
  } catch {
    return `Last published by ${pub}`;
  }
};
